// extracted by mini-css-extract-plugin
module.exports = {"container":"shared-ui-header-v2_container__fSJN8","sharedUiHeader":"shared-ui-header-v2_sharedUiHeader__Or69g","dropdownModal":"shared-ui-header-v2_dropdownModal__NJKAe"};